import React, {Component} from 'react';
import ContactFormInput from './ContactFormInput';
import ContactFormCheckbox from './ContactFormCheckbox';
import ContactFormSubmitButton from './ContactFormSubmitButton';
import ContactFormOverlay from './ContactFormOverlay';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import {withStyles} from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';

const styles = {
	root: {
		fontFamily: "futura-pt, sans-serif",
		fontWeight: 400,
		padding: '10px 20px',
		background: 'rgb(67, 170, 140)',
		color: 'white',
		fontSize: '1rem',
		width: 'auto',
		'&$focused': {
			color: 'white'
		},
	},
	focused: {},
	fieldset: {
		border: '1px solid rgba(0, 0, 0, 0.23)',
		padding: '10px 20px',
		borderRadius: '.25rem',
		display: 'flex'
	},
	textField: {
		fontFamily: "futura-pt, sans-serif",
		fontWeight: 400
	},
};

class ContactForm extends Component {
	constructor(props) {
		super(props);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleSelect = this.handleSelect.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.state = {
			isValid: false,
			isSubmitted: false,
			success: false,
			isInProgress: false,
			isError: false,
			form: {
				name: {
					name: 'name',
					label: 'Name',
					value: '',
					type: 'text',
					errorMessage: 'Please enter your name',
					required: true,
					pattern: '',
					isValid: false
				},
				email: {
					name: 'email',
					label: 'Email',
					value: '',
					type: 'email',
					errorMessage: 'Please enter your email',
					required: true,
					pattern: '',
					isValid: false
				},
				phone: {
					name: 'phone',
					label: 'Phone',
					value: '',
					type: 'tel',
					errorMessage: 'Please enter your phone',
					required: true,
					pattern: '^\\D?(\\d{3})\\D?\\D?(\\d{3})\\D?(\\d{4})$',
					isValid: false
				},
				website: {
					name: 'website',
					label: 'Website',
					value: '',
					type: 'text',
					errorMessage: 'Please enter your website URL',
					required: false,
					isValid: false,
					pattern: '[-a-zA-Z0-9@:%_\\+.~#?&//=]{2,256}\\.[a-z]{2,4}\\b(\\/[-a-zA-Z0-9@:%_\\+.~#?&//=]*)?'
				},
				cbWebsiteDesign: {
					name: 'needs[]',
					value: 'Website Design',
					id: 'webDesign',
					type: 'checkbox',
				},
				cbWebAppDev: {
					name: 'needs[]',
					value: 'Web Application Development',
					id: 'webAppDev',
					type: 'checkbox'
				},
				cbEcommerce: {
					name: 'needs[]',
					value: 'E-Commerce Development',
					id: 'eCommerce',
					type: 'checkbox'
				},
				cbWebPlatform: {
					name: 'needs[]',
					value: 'Web Platform Management',
					id: 'webPlatform',
					type: 'checkbox'
				},
				cbContentCreation: {
					name: 'needs[]',
					value: 'Content Creation & Management',
					id: 'contentCreation',
					type: 'checkbox'
				},
				cbDigitalMarketing: {
					name: 'needs[]',
					value: 'SEO & Digital Marketing',
					id: 'digitalMarketing',
					type: 'checkbox'
				},
				timeframe: {
					name: 'timeframe',
					value: '',
					options: [
						'now - 1 months',
						'1 - 3 months',
						'3 - 6 months',
						'6+ months'
					]
				}
			}
		};
	}

	handleChange(e) {
		const {target, target: {form, value, name}} = e;
		this.setState((state) => {
			const stateUpdates = {};
			const formObject = state.form;
			for (const prop in formObject) {
				if (formObject.hasOwnProperty(prop) && formObject[prop].name === name) {
					const field = formObject[prop];
					field.isValid = target.validity.valid;
					field.value = value;
					stateUpdates[prop] = field;
				}
			}
			return {
				isValid: form.checkValidity(),
				...stateUpdates
			}
		});
	}

	handleSelect(e) {
		this.setState(state => {
			const formObject = state.form;
			formObject.timeframe.value = e.target.value;
			return {
				form: formObject
			}
		});
	}

	handleSubmit(e) {
		e.preventDefault();
		window.scrollTo(0, 0);
		this.setState({isSubmitted: true, isInProgress: true, isError: false});
		const method = "POST";
		const body = new FormData(e.target);
		fetch('/api/src/', {method, body})
			.then(response => {
				this.setState({isInProgress: false});
				return response.json();
			})
			.then(({type, body}) => {
				if (type === 'errors') {
					let stateUpdates = {};
					this.setState((state) => {
						for (const errorField of body) {
							for (const prop in state) {
								if (state.hasOwnProperty(prop) && state[prop].name === errorField) {
									const field = state[prop];
									field.isValid = false;
									stateUpdates[prop] = field;
								}
							}
						}
						return stateUpdates;
					});
				} else {
					this.setState({success: true});
				}
			})
			.catch(error => {
				console.log(error);
				this.setState({isError: true})
			});
	}

	render() {
		const {classes} = this.props;
		if (this.state.isSubmitted && this.state.success) {
			return (
				<div className='text-center'>
					<h2>Thanks for reaching out!</h2>
					<p>We'll be in touch shortly</p>
				</div>
			)
		}
		return (
			<React.Fragment>
				<ContactFormOverlay isInProgress={this.state.isInProgress}/>
				<form noValidate id='contact-form' onSubmit={this.handleSubmit}>
					<h2>Contact Us</h2>
					<p className={this.state.isError ? 'd-block alert alert-danger' : 'd-none'}><strong>An Error
						Occurred</strong></p>
					<p>
						<small>*required</small>
					</p>
					<fieldset disabled={this.state.isInProgress}>
						<ContactFormInput name={this.state.form.name.name}
						                  label={this.state.form.name.label}
						                  type={this.state.form.name.type}
						                  required={this.state.form.name.required}
						                  isValid={this.state.form.name.isValid}
						                  errorMessage={this.state.form.name.errorMessage}
						                  onChange={this.handleChange}/>

						<ContactFormInput name={this.state.form.email.name}
						                  label={this.state.form.email.label}
						                  type={this.state.form.email.type}
						                  required={this.state.form.email.required}
						                  isValid={this.state.form.email.isValid}
						                  errorMessage={this.state.form.email.errorMessage}
						                  onChange={this.handleChange}/>

						<ContactFormInput name={this.state.form.phone.name}
						                  label={this.state.form.phone.label}
						                  type={this.state.form.phone.type}
						                  required={this.state.form.phone.required}
						                  pattern={this.state.form.phone.pattern}
						                  isValid={this.state.form.phone.isValid}
						                  errorMessage={this.state.form.phone.errorMessage}
						                  onChange={this.handleChange}/>

						<ContactFormInput name={this.state.form.website.name}
						                  label={this.state.form.website.label}
						                  type={this.state.form.website.type}
						                  required={this.state.form.website.required}
						                  pattern={this.state.form.website.pattern}
						                  isValid={this.state.form.website.isValid}
						                  errorMessage={this.state.form.website.errorMessage}
						                  formSubmitted={this.state.isSubmitted}
						                  onChange={this.handleChange}/>

						<FormControl component='fieldset' disabled={this.state.isInProgress}
						             className={classes.fieldset + ' mt-4'}>
							<FormLabel component='legend'
							           classes={{root: classes.root, focused: classes.focused}}>How can we help
								you?</FormLabel>
							<ContactFormCheckbox {...this.state.form.cbWebsiteDesign}/>
							<ContactFormCheckbox {...this.state.form.cbWebAppDev}/>
							<ContactFormCheckbox {...this.state.form.cbEcommerce}/>
							<ContactFormCheckbox {...this.state.form.cbWebPlatform}/>
							<ContactFormCheckbox {...this.state.form.cbContentCreation}/>
							<ContactFormCheckbox {...this.state.form.cbDigitalMarketing}/>
						</FormControl>

						<TextField select
						           fullWidth
						           disabled={this.state.isInProgress}
						           id='timeframe'
						           margin='normal'
						           name='timeframe'
						           label='What is your timeframe?'
						           value={this.state.form.timeframe.value}
						           InputProps={{classes: {underline: classes.underline}}}
						           InputLabelProps={{classes: {root: classes.textField}}}
						           onChange={this.handleSelect}>
							{this.state.form.timeframe.options.map(option => <MenuItem key={option}
							                                                           value={option}>{option}</MenuItem>)}
						</TextField>
						<TextField fullWidth
						           id="comments"
						           label="Anything else we should know?"
						           InputLabelProps={{classes: {root: classes.textField}}}
						           name='comments'
						           multiline
						           rows="5"
						           margin="normal"
						           variant="outlined"/>
						<input id='token' name='token' type='hidden' value='1234567890'/>
					</fieldset>
					<ContactFormSubmitButton isValid={this.state.isValid}/>
				</form>
			</React.Fragment>
		);
	}
}

export default withStyles(styles)(ContactForm);